import React, {
    createContext,
    useContext,
    useEffect,
    useState,
    useCallback,
} from "react";
import { loadContent, saveContent, updateSection } from "../lib/store";
import { DEFAULT_CONTENT } from "../lib/defaults";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
    const [content, setContent] = useState(DEFAULT_CONTENT);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        setLoading(true);
        const data = await loadContent();
        setContent(data);
        setLoading(false);
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const update = useCallback(async (key, value) => {
        const next = await updateSection(key, value);
        setContent(next);
        return next;
    }, []);

    const replace = useCallback(async (next) => {
        await saveContent(next);
        setContent(next);
    }, []);

    return (
        <SiteContext.Provider
            value={{ content, loading, refresh, update, replace }}
        >
            {children}
        </SiteContext.Provider>
    );
};

export const useSite = () => {
    const ctx = useContext(SiteContext);
    if (!ctx) throw new Error("useSite must be used inside SiteProvider");
    return ctx;
};
